import { FormDataDispositivoVM } from './../../../../../_entities/dispositivos/DispositivoVM';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ListaMarcas, ListaModelos } from '../../../../../_entities/dispositivos/AgregarDispositivoVM';
import { SimVM } from '../../../../../_entities/sims/SimVM';
import { ClienteVM } from '../../../../../_entities/clientes/ClienteVM'
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { DispositivoService } from '../../../services/dispositivo.service';
import { DispositivosDisponibles } from './../../../../../_entities/Administracion/DispositivosDisponibles';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';

@Component({
	selector: 'kt-alta-dispositivo',
	templateUrl: './alta-dispositivo.component.html',
	styleUrls: ['./alta-dispositivo.component.scss']
})
export class AltaDispositivoComponent implements OnInit {
	public marcasDispositivo: ListaMarcas[];
	public modeloDispositivo: ListaModelos;
	public simsDisponibles = [];
	public clientesRegistros: ClienteVM[];
	public titulo: string = 'Agregar Dispositivo'
	public dispositivoForm: FormGroup;
	public imeisDisponibles = [];
	public filteredImeis: Observable<any[]>;
	public filteredSims: Observable<any[]>;

	public simControl = new FormControl();

	public loading: boolean = false;
	public readonly: boolean = false;


	public param: any;
	public imei: any;

	constructor(private dispositivoService: DispositivoService,
		private toastService: ToastrService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private fb: FormBuilder) { }

	ngOnInit() {
		this.initForm();
		this.obtenerClientes();
		this.obtenerImeisDisponibles();
		this.obtenerMarcas();
		this.obtenerSimsDisponibles();

		this.activatedRoute.params.subscribe(
			async (param) => {
				this.imei = param['imei'];
				if (this.imei) {
					this.titulo = 'Editar Dispositivo'
					await this.obtenerDispositivo(this.imei);
					this.readonly = true;
				} else {

				}
			}
		);


		this.filteredImeis = this.dispositivoForm.get('IMEI').valueChanges.pipe(
			startWith(''),
			map(value => this.filterImeis(value))
		);

		this.filteredSims = this.simControl.valueChanges.pipe(
			startWith(''),
			map(value => this.filterSims(value))
		);
	}

	initForm() {
		this.dispositivoForm = this.fb.group({
			IMEI: ['', Validators.required],
			NumeroSerie: ['', Validators.required],
			IdMarca: ['', Validators.required],
			IdModelo: ['', Validators.required],
			IdSim: ['', Validators.required],
			IdCliente: ['', Validators.required]
		});
	}

	private filterImeis(value: string): string[] {
		const filterValue = value.toLowerCase();
		return this.imeisDisponibles.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
	}

	private filterSims(value: string): string[] {
		const filterValue = value.toLowerCase();
		return this.simsDisponibles.filter(option => option.numeroTelefonico.toLowerCase().indexOf(filterValue) === 0);
	}


	obtenerDispositivo(imei) {
		this.dispositivoService.obtenerDispositivo(imei).subscribe(
			async (res: FormDataDispositivoVM) => {
				await this.obtenerModelo(res.idMarca);
				await this.obtenerSimByImei(res.idSim);

				this.dispositivoForm.setValue({
					IMEI: res.imei,
					NumeroSerie: res.numeroSerie,
					IdMarca: res.idMarca,
					IdModelo: res.idModelo,
					IdSim: res.idSim,
					IdCliente: res.idCliente
				});
			}, (err) => { });
	}

	obtenerSimsDisponibles() {
		this.dispositivoService.obtenerSimsDisponibles().subscribe((res: SimVM[]) => {
			this.simsDisponibles = res;
		}, (err) => {
			this.toastService.error('Ocurrio un error al consultar los sims');
		});
	}

	obtenerImeisDisponibles() {
		this.dispositivoService.getImeisDisponibles().subscribe(
			(imeis: DispositivosDisponibles[]) => {
				imeis.forEach(imei => {
					this.imeisDisponibles.push(imei.id);
				})

			}, (err) => {
				this.toastService.error('Ocurrio un error al consultar los imeis');
			});
	}

	asignarSim(valor) {
		const sim = this.simsDisponibles.find(s => s.numeroTelefonico === valor);
		this.dispositivoForm.get('IdSim').setValue(sim.id);

	}

	obtenerSimByImei(idSim) {
		this.dispositivoService.obtenerSimById(idSim).subscribe((res: SimVM) => {
			this.simControl.setValue(res.numeroTelefonico);

			this.simsDisponibles.push(res);
		}, (err) => {
			this.toastService.error('Error al obtener sim');
		});
	}

	obtenerClientes(): void {
		this.dispositivoService.obtenerClientes(true).subscribe(
			(res) => {
				this.clientesRegistros = res;
			}, (err) => {
				console.log('Error al Obtener los clientes');
			}
		);
	}

	obtenerMarcas() {
		this.dispositivoService.obtenerMarcas().subscribe(
			(res: ListaMarcas[]) => {
				this.marcasDispositivo = res;
			}, (err) => { });
	}

	obtenerModelo(idMarca) {
		this.dispositivoService.obtenerModeloByMarca(idMarca).subscribe(
			(res: ListaModelos) => {
				this.modeloDispositivo = res;
			}, (err) => { });
	}


	onSubmit() {
		if (this.imei) {
			this.dispositivoService.actualizarDispositivo(this.imei, this.dispositivoForm.value).subscribe(
				(res) => {
					this.toastService.success('Dispositivo actualizado correctamente', 'Operación exitosa');
					this.router.navigateByUrl('home/administracion/dispositivos/dispositivo');
				}, (err) => {
					console.log('Error al actualizar el dispositivo', err);
				});
		} else {
			this.dispositivoService.agregarDispositivo(this.dispositivoForm.value).subscribe(
				(success) => {
					this.toastService.success('Dispositivo guardado correctamente', 'Operación exitosa');
					this.router.navigateByUrl('home/administracion/dispositivos/dispositivo');
				}, (err) => {
					console.log('Error', err);
				});
		}
	}

	onCancel() {
		this.router.navigateByUrl('home/administracion/dispositivos/dispositivo');
	}

}
